import { iam } from '@myap/ui-library/esm/profile'

const useCatapultAuth = () => {
  const { getEventBus, events, getTempAWSCreds, getAuthSession } = iam()
  const { isLoggedIn, basicProfile = {} } = getAuthSession()
  const bus = getEventBus()
  const { AWSLogin, AWSLoginFailed, Login, Logout } = events
  const hasAWSCreds = Boolean(getTempAWSCreds('apfym'))
  const [awsAuth, setAWSAuth] = useState({
    loading: !hasAWSCreds,
    loaded: hasAWSCreds,
    error: false,
  })
  const setAWSAuthLogin = () => setAWSAuth({ loaded: true, error: false, loading: false })
  const setAWSAuthLoginFailed = () => setAWSAuth({ loaded: false, error: true, loading: false })
  const [isAuthed, setAuth] = useState(isLoggedIn)
  const setLoggedIn = () => setAuth(true)
  const setLoggedOut = () => setAuth(false)

  useEffect(() => {
    bus.on(AWSLogin, setAWSAuthLogin)
    bus.on(AWSLoginFailed, setAWSAuthLoginFailed)
    bus.on(Logout, setLoggedOut)
    bus.on(Login, setLoggedIn)
    return () => {
      bus.off(AWSLogin, setAWSAuthLogin)
      bus.off(AWSLoginFailed, setAWSAuthLoginFailed)
      bus.off(Logout, setLoggedOut)
      bus.off(Login, setLoggedIn)
    }
  }, [])

  return { isAuthed, basicProfile, ...awsAuth }
}

export default useCatapultAuth
